import { render, staticRenderFns } from "./DispensationsCalendar.vue?vue&type=template&id=00cfc279"
import script from "./DispensationsCalendar.vue?vue&type=script&lang=js"
export * from "./DispensationsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports